import { PropsWithChildren } from "react"
import {
  DefaultValues,
  FormProvider,
  SubmitHandler,
  useForm,
  SubmitErrorHandler
} from "react-hook-form"
import LoadingIndicator from "../LoadingIndicator"
import { StyledForm, StyledFormLoading } from "./style"

type FormProps<T> = PropsWithChildren<{
  onValid: SubmitHandler<T>;
  onInvalid?: SubmitErrorHandler<T>;
  defaultValues: DefaultValues<T>;
  isPending?: boolean;
}>;

function Form<T>({
  defaultValues,
  onValid,
  onInvalid,
  isPending,
  children,
}: FormProps<T>) {
  const methods = useForm({
    defaultValues,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <StyledForm onSubmit={handleSubmit(onValid, onInvalid)}>
        {children}
        {isPending && (
          <StyledFormLoading>
            <LoadingIndicator />
          </StyledFormLoading>
        )}
      </StyledForm>
    </FormProvider>
  );
}

export default Form;
